import placeholderImage from './placeholder.svg'

export const defaultImage = placeholderImage.src
